import MapShow from '../components/map/Show.vue'
import MapAr from '../components/map/Ar'

export default [
  { name: 'MapShow', path: '/map/', components: {'MapTab': MapShow}, meta: { requiresAuth: true } },
  { name: 'MapShowGeo', path: '/map/:geo', components: {'MapTab': MapShow}, meta: { requiresAuth: true } },
  { name: 'MapAr', path: '/map-ar', components: { default: MapAr}, meta: { navHidden: true, fullscreen: true } },
]
